export const FF_FEATURE_EXCEPTIONS_LIST = ['s23'];
